import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconProgressing,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';

export type AssetTaggingTaskInProgressPanelItemProps = {
  onCancel: () => void;
};

export const AssetTaggingTaskInProgressPanelItem = memo(({ onCancel }: AssetTaggingTaskInProgressPanelItemProps) => {
  return (
    <PaneItemTW
      avatar={<FileStatusIconProgressing />}
      title={
        <FileStatusTitle data-testid="ASSET_TAGGING_TASK_IN_PROGRESS_PANEL_ITEM_TITLE">Updating tags</FileStatusTitle>
      }
      subtitle={<FileStatusSubtitle className="truncate">Your tags will be applied shortly.</FileStatusSubtitle>}
      buttons={
        <FileStatusButton label="Cancel" onClick={onCancel}>
          <Close className="size-4" />
        </FileStatusButton>
      }
    />
  );
});

AssetTaggingTaskInProgressPanelItem.displayName = 'AssetTaggingTaskInProgressPanelItem';
